import React, { Component } from 'react';
import styled from 'styled-components';

import gallery from 'src/data/gallery';
import FullImage from './FullImage';
import Copy from './Copy';

class Wheel extends Component {
  state = {
    active: null,
  };

  handleMouseEnter = e => {
    const $el = e.target;
    this.setState({ active: $el.dataset.id });
  };

  handleClick = e => {
    const $el = e.target;
    this.setState({ active: $el.dataset.id });
  };

  handleMouseLeave = () => {
    this.setState({ active: null });
  };

  render() {
    return (
      <WheelStyles>
        <SVGContainer>
          <SVG viewBox="0 0 766 767">
            <defs>
              {gallery.map((galleryItem, index) => {
                return (
                  <path
                    d={galleryItem.pathDef}
                    id={`path-mask-${galleryItem.id}`}
                    key={index}
                  />
                );
              })}
            </defs>
            <g fill="none" fillRule="evenodd">
              <g id="teaser-v3.2-Desktop-HD" transform="translate(-337 -828)">
                <g id="gallery" transform="translate(336 828)">
                  {gallery.map((galleryItem, index) => {
                    const { id, pathDef, gTransform, image } = galleryItem;
                    return (
                      <g className="gallery" transform={gTransform} key={index}>
                        <mask id={`mask-image-${id}`} fill="#fff">
                          <use xlinkHref={`#path-mask-${id}`} />
                        </mask>
                        <use
                          id="Mask"
                          fill="#D8D8D8"
                          xlinkHref={`#path-mask-${id}`}
                        />
                        <image
                          mask={`url(#mask-image-${id})`}
                          x={image.x}
                          y={image.y}
                          width={image.width}
                          height={image.height}
                          xlinkHref={`/assets/images/gallery/thumbs/${id}.jpg`}
                        />
                        <Path
                          d={pathDef}
                          data-id={id}
                          onMouseEnter={this.handleMouseEnter}
                          onClick={this.handleClick}
                          onTouchStart={this.handleClick}
                          onMouseLeave={this.handleMouseLeave}
                          isHovering={this.state.active}
                        />
                      </g>
                    );
                  })}
                </g>
              </g>
            </g>
          </SVG>
          <FullImage
            style={{
              backgroundImage: `url(/assets/images/gallery/${
                this.state.active
              }.png)`,
            }}
            active={this.state.active}
          />
        </SVGContainer>
        <Copy active={!this.state.active} />
      </WheelStyles>
    );
  }
}

const WheelStyles = styled.div`
  display: inline-block;
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 767px;
  padding: 0 20px;
`;

const SVGContainer = styled.div`
  position: relative;
`;

const SVG = styled.svg`
  max-width: 100%;
  margin: 0 auto;
  pointer-events: none;
  display: block;
  max-width: 767px;
  width: 100%;

  #gallery {
  }
`;

const Path = styled.path`
  fill: ${props => {
    return props.isHovering ? '#505050' : 'transparent';
  }};
  mix-blend-mode: multiply;
  transition: all 0.5s;
  pointer-events: auto;
  position: relative;
  z-index: 1000;

  &:hover {
    fill: #f58320 !important;
  }
`;

export default Wheel;



// WEBPACK FOOTER //
// ./src/components/Gallery/elements/Wheel.js